import { PanelTable } from '~/components/ui';
import { routes } from '~/app/routes';
import { orDash } from '~/lib/orDash';

import type { MembershipRow } from '~/components/pages/mls-agreements/types';

interface MembershipListProps {
  memberships: MembershipRow[] | undefined;
  /** Which side of the membership the parent record is not: the customer for an MLS, the MLS for a customer. */
  nameHeader: 'Customer' | 'MLS';
  nameOf: (m: MembershipRow) => string;
}

// Read-only memberships of one record, shared by the MLS and customer pages; a row opens its membership.
export const MembershipList = ({ memberships, nameHeader, nameOf }: MembershipListProps) => (
  <PanelTable<MembershipRow>
    ariaLabel="Memberships"
    testId="mls-agreements-memberships"
    emptyMessage="No memberships yet."
    emptyDescription="Use Create membership to add one."
    data={memberships ?? []}
    getRowId={(m, i) => m.id ?? i}
    rowHref={(m) => (m.id ? routes.mlsAgreementsMembership(m.id) : null)}
    rowLabel={(m) => `Open membership for ${nameOf(m)}`}
    columns={[
      { header: nameHeader, render: nameOf },
      { header: 'Product', render: (m) => orDash(m.product) },
      { header: 'Status', render: (m) => orDash(m.agreementStatus) },
      { header: 'Expiration', render: (m) => orDash(m.agreementExpiration) },
    ]}
  />
);
